




import {Vue, Component, Prop} from 'vue-property-decorator'
import Utils from '@/utils'

@Component({
  name: 'WarningNote',
  components: {Card: Utils.loadComponent('proxy/Card/Card')},
})
export default class WarningNote extends Vue {
  @Prop() public warningText!: string
  @Prop() public severity: 'warning' | 'error' | 'info' | 'success' | undefined
}
